import { IconButton, Modal,ContextualMenu,mergeStyleSets, PrimaryButton, DefaultButton, Spinner, SpinnerSize } from "@fluentui/react";
import React, { useEffect, useState,useContext } from "react";
import { CUSTOM_STYLES } from "../../../../constants/Constants";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import ModalFooter from "../../../../components/Modal/ModalFooter";
import ModalMain from "../../../../components/Modal/ModalMain";

const ConfirmModal = (props) => {

    let PrimaryButtonList = [
      {
          title:"Continue",
          onclick: ()=>{
            props.handleRemoveTemplate(props.data.event, props.data.key, props.data.index);
            props.hideModal();
     },
      }
    ];
    let DefaultButtonList = [
      {
          title:"Cancel",
          onclick: props.hideModal
      }
    ];

    const modalDetails = {
      header: <ModalHeader updatedModal={true} heading={props.heading} handleCancel={props.hideModal}/>,
      footer : <ModalFooter PrimaryButtonList={PrimaryButtonList} DefaultButtonList={DefaultButtonList}/>,
      body : <>
      <div className='confirm-modal-content'>
                  <div className='message-container'>
                      <h1 className='confirm-message'>{props.description}</h1>
                  </div>
              </div></>,
      width : "600px"
    }

    return (
      <>
      {props.isModalOpen && 
      <ModalMain updatedModal={true} showModal={props.isModalOpen} modalDetails={modalDetails}/>
      }
      </>
    )
}

export default ConfirmModal;